module.exports = function getResource(label, vars = []) {
    const resources = { seeAll: `Voir tout ${vars[0]}` };

    return resources[label];
};
